import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseApiService } from './base-api.service';
import { environment } from '../../../environments/environment';
import { Nomination } from '../models/nomination';
import { PagingOptions } from '../models/paged-options';

@Injectable({
  providedIn: 'root',
})
export class NominationService extends BaseApiService<Nomination> {
  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/nominations`);
  }

  searchNominations(searchText: string, statuses: string[], pagingOptions: PagingOptions) {
    return this.getPagedList<Nomination>(pagingOptions, `${this.baseApiUrl}/search`, {
      searchText: searchText ?? '',
      statuses: statuses.length > 0 ? statuses : undefined,
    });
  }

  getNomination(id: string) {
    return this.get(id);
  }
}
